export default __webpack_public_path__ + "static/media/CNo.83-1.11d97ac9.jpg";